// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cFcz7","toggle":"styles_toggle__1OTZy","preview":"styles_preview__1ZxL6"};